<template>
  <div id="settings-wrapper">
    <!-- Added Info -->
    <v-snackbar top v-model="showUpdateMessage" color="#16c96d">
      <v-icon>mdi-check-circle-outline</v-icon><span class="font-weight-bold pl-2"> The selected keywords have been added to your selected research! </span>
    </v-snackbar>
    <v-snackbar top v-model="showAddMessage" color="#16c96d">
      <v-icon>mdi-check-circle-outline</v-icon><span class="font-weight-bold pl-2"> The selected keywords have been saved as a new research! </span>
    </v-snackbar>
    <v-snackbar top v-model="showDeleteMessage" color="#16c96d">
      <v-icon>mdi-check-circle-outline</v-icon><span class="font-weight-bold pl-2"> The selected keywords have been deleted! </span>
    </v-snackbar>
    <!-- different locations in clipboard Info -->
    <v-snackbar top color="#fcba03" v-model="showLocError">    
      <v-row> <v-col cols='1'><v-icon class="pl-3">mdi-alert-circle-outline</v-icon> </v-col> <v-col> <span class="font-weight-bold">You have keywords in your clipboard with searchvolume data from a different location. Please delete these keywords first. </span> </v-col>   </v-row> 
    </v-snackbar>
    <v-card
      id="settings"
      class="py-2 px-4"
      color="rgba(0, 0, 0, .3)"
      dark
      flat
      link
      min-width="100"
      style="position: fixed; top: 115px; right: -35px; border-radius: 8px;"
    >
      <v-icon large>
        mdi-text-box-plus
      </v-icon>
    </v-card>
    <v-menu
      v-model="sidebarmenu"
      :close-on-content-click="false"
      activator="#settings"
      bottom
      content-class="v-settings"
      left
      nudge-left="8"
      offset-x
      origin="top right"
      transition="scale-transition"
    >
      <v-card
        class="text-center mb-0"
        width="300"
      >
        <v-card-text v-if="keywords.length === 0">
          <strong class="d-inline-block" id="maintitle"> Clipboard </strong>
         <hr class="my-3" id="divider"/>
          <v-alert type="info" color='#42DEFA'>
            <b class="infotext"><p> You can add keywords to the Clipboard from everywhere!</p><p class="infotext">Use this button to insert keywords:</p> </b>
            <div >
              <v-btn  fab dark small color="grey" title="add keyword(s) to collection" class="fabicon btnpadding">
                  <v-icon dark>mdi-text-box-plus</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </v-card-text>
        <v-card-text v-else>
          <strong class="mb-3 d-inline-block" id="maintitle"> Clipboard </strong>
           <v-data-table
                v-bind="tblOptions"
                :headers="headers"
                :items="keywords"
                height="inherit"
                item-key="keyword"
                :items-per-page="perpage"
                dense
                >
                  <template  v-slot:item.keyword="{ item }"> 
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        
                          <div v-on="on">{{shortenKeyword(item.keyword)}}</div>
                          <!-- add to collection -->
                      
                      </template>
                      <span>{{item.keyword}}</span>
                    </v-tooltip> 
                  </template>
                  <template  v-slot:item.avgsv="{ item }"> <v-chip small color="#42DEFA">{{ $helpers.formatNumber(item.avgsv) }}</v-chip> </template>
                  <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  @click="deleteItem(item)"
                >
                  mdi-close
                </v-icon>
              </template>
            </v-data-table>
          <hr class="my-3" id="divider"/>
<!-- action buttons -->
          <div class="actionBtns">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-5" dark fab color="#42DEFA" @click="downloadDialog = true" small v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-cloud-download</v-icon>
                </v-btn>
              </template>
              <span>download keywords</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-5" color='#42DEFA' small fab dark @click="dialog=true" v-bind="attrs" v-on="on" >
                    <v-icon dark>mdi-content-save</v-icon>
                  <!-- save new collection -->
                </v-btn>
                </template>
              <span>save new collection</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-5" color='#42DEFA' fab small dark @blur="getExistingLists"  @click="researchDialog=true" v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-file-plus</v-icon>
                  <!-- add to collection -->
                </v-btn>
              </template>
              <span>add to an existing collection</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color='#42DEFA' fab small dark @blur="getExistingLists"  @click="deleteQuestion = true" v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-delete</v-icon>
                  <!-- add to collection -->
                </v-btn>
              </template>
              <span>delete all keywords</span>
            </v-tooltip>
          </div>
<!--save dialog -->
          <v-dialog v-model="dialog" scrollable max-width="300px">
                <!-- <template v-slot:activator="{ on }">
                  <v-btn color='primary' v-on="on" block>save new research</v-btn>
                </template> -->
                <v-card>
                  <strong id="title" class="mb-3 d-inline-block">Save Research</strong>
                  <v-card-text  id="savebody">
                  <v-container fluid grid-list-xl id="kwpform">
                            <v-layout align-center wrap >
                                <v-flex xs12  id="kwpformflex">
                                  <span class="existMessage">
                                    {{existMessage}}
                                  </span>
                                  <v-text-field
                                      label="collection name"
                                      v-model="documentName"
                                      prepend-icon="mdi-file-document"
                                      @focus="disableExistMessage"
                                    />
                                </v-flex>
                                 <!-- <v-flex xs12 id="kwpformflex">
                                    <v-select
                                        v-model="collectionType"
                                        :items="types"
                                        item-text="value"
                                        :menu-props="{'maxHeight':150 }"
                                        label="collection type"
                                        prepend-icon="mdi-format-list-bulleted-type"
                                        return-object
                                        overflow
                                        attach>
                                    </v-select>
                                </v-flex> -->
                                <v-flex xs12 id="kwpformflex">
                                    <v-select
                                        v-model="selectedLocation"
                                        :items="searchvolumeFromItems"
                                        item-text="loc"
                                        :menu-props="{'maxHeight':150 }"
                                        label="country for searchvolume"
                                        prepend-icon="mdi-map-marker"
                                        return-object
                                        disabled
                                        >
                                    </v-select>
                                </v-flex>
                                <v-flex xs12 id="kwpformflex">
                                  <!-- <v-switch
                                        v-model="publish"
                                        color= "info"
                                        :label="switchlbl"
                                  ></v-switch> -->
                                </v-flex>
                            </v-layout>
                        </v-container>
                  </v-card-text>
                  <v-divider/>
                  <v-card-actions>
                    <v-btn color='#42DEFA' dark @click="prepareSaveResearch(keywords)" block>save research</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
<!-- Download Dialog -->
    <v-dialog v-model="downloadDialog" scrollable max-width="450px" id="downloaddialog">
        <v-card>
            <strong id="title" class="mb-3 d-inline-block">Save Research</strong>
            <v-card-text class="selectfiletype" id="selectfiletype">
              <v-select
                    v-model="doctype"
                    :items="doctypes"
                    filled
                    item-text="value"
                    item-value="data"
                    return-object
                    :prepend-icon="doctype.icon"
                    label="select file format"
                    attach
              ></v-select>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions id="downloadactions">
                <v-spacer></v-spacer>
                <v-btn block  dark color="#42DEFA" v-on:click="download()">Download</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
 <!-- add to research dialog -->
              <v-dialog v-model="researchDialog" max-width="400px" class="text-center">
                <v-card>
                  <strong id="title2" class="mb-3 d-inline-block text-center">Add to research</strong>
                  <v-card-text>
                        <v-select
                            v-model="selectedList"
                            :items="existLists"
                            item-text="listname"
                            label="Available researches"
                            prepend-icon="mdi-format-list-bulleted"
                            return-object
                            class="pt-5 pb-5"
                            id="addtocollection">
                        </v-select>
                  </v-card-text>
                  <v-divider/>
                  <v-card-actions>
                    <v-btn color='#42DEFA' dark @click="checkForUpdate" block>add keywords to research</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
<!-- Delete Dialog List -->
          <v-dialog v-model="deleteQuestion" max-width="300">
            <v-card>
              <v-card-title style="{text-align: center}"> Are you sure?</v-card-title>
              <v-card-text class="text-center">
                <v-btn class="mr-3" text @click="deleteQuestion = false"> Nevermind </v-btn>
                <v-btn color="#42DEFA" text @click="deleteList()"  >  Yes </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
<!-- Delete Dialog Item -->
          <!-- <v-dialog v-model="deleteQuestionItem" max-width="300">
            <v-card>
              <v-card-title style="{text-align: center}"> Are you sure?</v-card-title>
              <v-card-text class="text-center">
                <v-btn class="mr-3" text @click="deleteQuestionItem = false"> Nevermind </v-btn>
                <v-btn color="#42DEFA" text @click="deleteItem()"  >  Yes </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog> -->
<!-- Keep Keywords in List Dialog -->
          <v-dialog v-model="keepKeywordsDialog" max-width="350">
            <v-card>
              <v-card-title style="{text-align: center}"> Keep keywords in clipboard?</v-card-title>
              <v-card-text class="text-center">
                <v-btn class="mr-3" text @click="keywords = [];keepKeywordsDialog = false"> No </v-btn>
                <v-btn color="#42DEFA" text @click="keepKeywordsDialog = false"  >  Yes </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>


<script>
  // Mixins
  import { onlyKeywords } from './helper/utils';
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState } from 'vuex'
  // import DownloadDialog from "./DownloadDialog.vue";

  export default {
    name: 'DashboardCoreSettings',
    // components: {
    //   DownloadDialog
    // },
    mixins: [Proxyable],

    data: () => ({
      get selectedLocation() {
        if (localStorage.loc) {
          return JSON.parse(localStorage.loc)
        } else {
          return { loc: "Germany", value: "2276", cc:"de" }
        }
      },
      get keywords() {
        if (localStorage.getItem('keywords')) {
          if (localStorage.getItem('keywords') != "[object Object],[object Object]") {
            return JSON.parse(localStorage.getItem('keywords'));
          }else{
            return[]
          }
        } else {
          return [];
        }
      },

      set keywords(value) {
        localStorage.setItem("keywords", JSON.stringify(value));
      },
      get downloadheaders() {
        if (localStorage.getItem('downloadheaders')) {
          if (localStorage.getItem('downloadheaders') != "[object Object],[object Object]") {
            return JSON.parse(localStorage.getItem('downloadheaders'));
          }else{
            return[]
          }
        } else {
          return [];
        }
      },
      collectionType: {value: "Research", data: "research"},
      types: [
        { value: "Research", data: "research"}, 
        // { value: "Rankings", data: "rankings"}
        ],
      doctypes: [{ value: "Microsoft Excel (.xlsx)", data: "json2xls", icon: "mdi-microsoft-excel"}, { value: "Comma separated values (.csv)", data: "json2csv", icon: "mdi-file-delimited"},],
      doctype: { value: "Microsoft Excel (.xlsx)", data: "json2xls", icon: "mdi-microsoft-excel"},
      downloadDialog: false,
      tblOptions: {
        'footer-props': {
          'items-per-page-options': [5, 10, 15]
        }
      },
      tblheight: 150,
      perpage: 10,
      switchlbl: "don´t publish",
      auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
      apiUrl: process.env.VUE_APP_APIURL,
      documentName: "",
      searchvolumeFrom: localStorage.selectedLocation ?  JSON.parse(localStorage.selectedLocation) : { loc: "Germany", value: "2276", cc:"de" },
      searchvolumeFromItems: [
            {loc: "France", value: "2250" },
            {loc: "Spain", value: "2724" },
            {loc: "Netherlands", value: "2528" },
            {loc: "Germany", value: "2276" }, 
            {loc: "Austria", value: "2040" },
            {loc: "Switzerland", value: "2756" },
            {loc: "United Kingdom", value: "2826" },
            {loc: "Italy", value: "2380" },
            {loc: "Poland", value: "2616" },
            {loc: "Russia", value: "2643" },
            {loc: "Croatia", value: "2191" },
            {loc: "Czechia", value: "2203" },
            {loc: "Slovakia", value: "2703" },
            {loc: "Slovenia", value: "2705" }
          ], 
      publish: true,
      existMessage: "",
      existLists: [],
      selectedList: {},
      dialogm1: '',
      dialog: false,
      researchDialog: false,
      listkeywords: [],
      headers: [ {
            text: 'Keyword',
            align: 'left',
            sortable: true,
            value: 'keyword',
          },
          { 
            text: 'Vol.', 
            value: 'avgsv',
            align: 'left',
            sortable: true,
          },
          { text: '', value: 'action', sortable: false },],
      color: '#00CAE3',

      menu: false,
      keepKeywordsDialog: false,
      showAddMessage: false,
      showUpdateMessage: false,
      showDeleteMessage: false,
      deleteQuestion: false,
      deleteQuestionItem: false,
      selectedItem: [],
      showLocError: false,
    }),

    computed: {
      ...mapState(['barImage']),
      sidebarmenu:{
        get(){
          return this.$store.state.sidebarMenu;
        },
        set(value){
          this.$store.dispatch("CHANGE_SIDEBARMENU");
        }
      }
 
    },

    watch: {
      publish(val) {
        if (val === true) this.switchlbl = "publish"
        else  this.switchlbl = "don´t publish"
        
      },
    },

    methods: {
      shortenKeyword(keyword){
        if(keyword.length > 15){
          let temp = keyword.slice(0, 15)
          return temp + "..."
        }else{
          return keyword
        }
        
      },
      download(){
        let keywords = JSON.parse(JSON.stringify(this.keywords))
        keywords.sort(function(a, b){return b.avgsv - a.avgsv});
        let fields = this.$helpers.deleteDownloadColumns(this.downloadheaders);

        // //console.log(fields)
        this.$http.post(process.env.VUE_APP_APIURL + '/research/' + this.doctype.data, {data: this.$helpers.deleteDownloadAttributes(keywords), columns: fields }, { headers: {'Authorization': this.auth }})
          .then(function(response){
          window.location = process.env.VUE_APP_APIURL +"/" + response.body;
          this.downloadDialog = false; 
          // this.downloaded = true;      
        });
      },
      deleteList(){
        this.keywords = [];
        this.showDeleteMessage = true;
        this.deleteQuestion = false;
      },
      test(){
        // console.log(localStorage.getItem('keywords'))
      },
      getTableHeight() {
        return 150
      },
      // prepareDeleteItem(item){
      //   this.selectedItem = item;
      //   this.deleteQuestionItem = true;
      // },
      deleteItem(item){ 
        for (let index = 0; index < this.keywords.length; index++) {
          if (this.keywords[index].keyword == item.keyword) {
            this.showDeleteMessage = true;
            this.deleteQuestionItem = false;
            let kw =  this.keywords;
            kw.splice(index, 1);
            localStorage.setItem("keywords", JSON.stringify(kw));
            this.$store.dispatch("CHANGE_SIDEBARMENU");
            this.$store.dispatch("CHANGE_SIDEBARMENU");
          }
        }
      },
      disableExistMessage: function(){
          this.existMessage = "";
      },
      checkIfExists: function(){
        return new Promise((resolve, reject) => {
          if (this.documentName != "") {
            this.$http.get(this.apiUrl+'/research/namecheck/' +  this.documentName + '&' + localStorage.company_id, { headers: {'Authorization': this.auth}})
            .then(function(response){
              if (response.body.error) {
                this.existMessage = "That name already exists, please try something else";
                this.documentName = "";
                resolve(false);
              }else{
                resolve(true);
              }
              
            });
          }
        })
      },
      getExistingLists(){
        this.$http.get(this.apiUrl+'/research/availablelists/research&' +  localStorage.id + '&' + localStorage.company_id, { headers: {'Authorization': this.auth}})
          .then(function(response){
            this.existLists = response.body;
        });
      },
      async prepareSaveResearch(keywords){
        var checkIfExists = await this.checkIfExists();
        if(checkIfExists){
          // check if name is only alphanumeric
          var validString = /^[a-zA-Z0-9\u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00df\u0020]+$/i.test(this.documentName);
          if(validString && this.documentName.length > 2){
            // //console.log("valid")
            this.saveResearch(true, 0, keywords, false);
          }else{
            this.existMessage = "Please only use alphabetic and numeric characters!";
            this.documentName = "";
          }
          
        }

      },
      

      checkForUpdate(){
        this.$http.get(this.apiUrl +'/research/listdata/'+ this.selectedList.listname + '&' + localStorage.company_id, { headers: {'Authorization': this.auth }}).then(response => {
          if (response.status == 200) {
            // //console.log(response)
            
            var locObject = JSON.parse(localStorage.loc)
            console.log(locObject)
            if(response.body[0].mdata.langloc.loc == locObject.value){
              

              this.$http.get(this.apiUrl+'/research/keywords/' +  this.selectedList.listname + '&' + localStorage.company_id, { headers: {'Authorization': this.auth}})
                .then(function(keyworddata){
                  let dbKeywords = onlyKeywords(keyworddata.body);

                  let uniqueKeywords = this.$helpers.removeDuplicatesByAttribute(this.keywords.concat(dbKeywords), "keyword");
                  let onlyoldKeywords = dbKeywords.filter(ar => !this.keywords.find(rm => (rm.keyword === ar.keyword) ));
                  let onlynewKeywords = this.keywords.filter(ar => !dbKeywords.find(rm => (rm.keyword === ar.keyword) ));

                //  //console.log("FrontendKeywords:" + JSON.stringify(this.keywords))
                //  //console.log("BackendKeywords:" + JSON.stringify(dbKeywords))

                //  //console.log("Keywords to save:" + JSON.stringify(onlynewKeywords))
                //  //console.log("Keywords to update (if Db data old):" + JSON.stringify(onlyoldKeywords))

                //  //console.log("db month: "+ response.body[0].mdata.updated + "actual month: "+ this.keywords[0].search_volumes[0].month )
                this.showUpdateMessage = true;

                //  let updatedSplits = response.body[0].mdata.updated.split("/");

                
                  // if no Update for DB-Data is available
                  // if(updatedSplits[0] == this.keywords[0].search_volumes[0].month){
                    // //console.log(updatedSplits)
                    if(onlynewKeywords.length > 0){
                      this.saveResearch(false, uniqueKeywords.length, onlynewKeywords, true);
                    }else{
                      this.endSaveAndUpdate();
                    }
                  // }else{
                  //   if(onlyoldKeywords.length > 0){
                  //     this.$http.delete(this.apiUrl+'/research/deleteKeywords/' +  this.selectedList.listname + '&' + localStorage.company_id, { headers: {'Authorization': this.auth}})
                  //      .then(function(deletedata){
                  //       this.updateResearch(uniqueKeywords.length, onlyoldKeywords, this.keywords);
                  //     });
                  //   }else{
                  //     this.$http.delete(this.apiUrl+'/research/deleteKeywords/' +  this.selectedList.listname + '&' + localStorage.company_id, { headers: {'Authorization': this.auth}})
                  //      .then(function(deletedata){
                  //       this.saveResearch(false, uniqueKeywords.length, this.keywords, true);
                  //     });
                  //   }                  
                  // }
              });
            }else{
              this.showLocError = true;
            }
          }
        });
      },
      
      
      ///HIER WEITER
      updateResearch(newCount, keywordsToRefresh, newKeywords ){
        // //console.log(keywordsToRefresh)
        this.saveResearch(false, newCount, newKeywords, false);
        let data = {
          keywords: keywordsToRefresh,
          attributes:{
            name: this.selectedList.listname,
            user: localStorage.id,
            type: this.collectionType.data,
            shared: this.publish,
            editable: true,
            lang: this.searchvolumeFrom.lang,
            loc: this.searchvolumeFrom.loc,
            value: this.searchvolumeFrom.value
          },
          count: newCount,
          company_id: localStorage.company_id,
          user_id: localStorage.id
        }
        // //console.log("update db keywords")
        this.$http.post(this.apiUrl +'/research/save', data, { headers: {'Authorization': this.auth }}).then(response => {
          if (response.status == 200) {
            this.endSaveAndUpdate();
          }
        });
        
        
      },
      endSaveAndUpdate(){
        this.documentName = "";
        this.dialog = false;
        this.$store.dispatch("CHANGE_SIDEBARMENU");
        // this.keywords = [];
        this.researchDialog = false;
        this.keepKeywordsDialog = true;
      },
      // deleteOldKeywords(){
      //   // console.log(this.keywords)
      //   if(this.keywords.length > 0){
      //     this.$http.get(this.apiUrl+'/service/actualmonth/get', { headers: {'Authorization': this.auth}})
      //     .then(function(response){
      //       var datesplits = response.body.split("/");
      //       // console.log(parseInt(datesplits[0]))
      //       // console.log(this.keywords[0].search_volumes[0].month)
      //       try {
      //         if(this.keywords[0].search_volumes[0].month !== JSON.parse(datesplits[0])){
      //           // console.log("Deleted outdated keywords in Clipboard")
      //           this.keywords = [];

      //         }
      //       } catch (error) {
      //         this.keywords = [];
      //       }
            
            
      //     });
      //   }
        
      // },
      saveResearch(newlist, newCount, keywords, updateCount){
        this.showAddMessage = true;
        // //console.log("saving frontend Keywords")
        console.log(keywords)
        // let name = "";
        
        // if(newlist){
        //   name = this.documentName;
        // }else{
        //   name = this.selectedList.listname;
        // }
        let data = {
          keywords: this.$helpers.removeDuplicatesByAttribute(keywords, "keyword"),
          attributes:{
            name: this.documentName,
            user: localStorage.id,
            type: this.collectionType.data,
            shared: this.publish,
            editable: true,
            lang: this.searchvolumeFrom.lang,
            loc: this.searchvolumeFrom.value,
            value: this.searchvolumeFrom.loc
          },
          // newlist: newlist,
          // newCount: newCount,
          // updateCount: updateCount,
          company_id: localStorage.company_id
        }
        this.$http.post(this.apiUrl +'/research/create', data, { headers: {'Authorization': this.auth }}).then(response => {
          if (response.status == 200) {
            this.endSaveAndUpdate();
          }
        });
      },
    },
    mounted () {
      //look for old keywords and delete if too old
      // console.log(localStorage)
      // this.deleteOldKeywords();
    },
    updated(){
      // console.log(this.keywords.length)   
    }
  }
</script>
<style  scoped>
.v-btn{
margin-top: 10px;
}
.existMessage{
  color: red;
}
#maintitle{
  padding-top: 3px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center !important;
  font-size: 1em;
}
#title{
  padding-top: 16px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center !important;
  color:#212529;
  font-size: 1em;
}
#savebody{
  padding-top: 0%
}
#kwpformflex{
   padding-top: 0%
}
#heading{
  font-size: 1.2em;
}
.actionBtns{
  margin-top: -10px !important;
}
#divider{
        border: 1px solid rgb(231, 231, 231);
        border-radius: 1px;
}
.btnpadding{
  margin-right: 50px;
}
#title2{
  padding-top: 16px;
  line-height: 25px;
  font-size: 12px;
  padding-left: 125px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center !important;
  color:#212529;
  font-size: 1em;
}
#addtocollection{
  padding-top: 15px;
  padding-bottom: 15px;
}

</style>
<style lang="sass" scoped>
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
  .infotext
    text-align: left
  
  .v-data-footer__select
    display: none
</style>
